var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.4917 1.66669H6.50841C3.47508 1.66669 1.66675 3.47502 1.66675 6.50835V13.4834C1.66675 16.525 3.47508 18.3334 6.50841 18.3334H13.4834C16.5167 18.3334 18.3251 16.525 18.3251 13.4917V6.50835C18.3334 3.47502 16.5251 1.66669 13.4917 1.66669Z",
    fill: "#B90022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10851 12.7C5.97517 12.7 5.84184 12.6583 5.72517 12.5667C5.45017 12.3583 5.40017 11.9667 5.60851 11.6917L7.59184 9.11667C7.83351 8.80834 8.17517 8.60834 8.56684 8.55834C8.95017 8.50834 9.34184 8.61667 9.65017 8.85834L11.1752 10.0583C11.2335 10.1083 11.2918 10.1083 11.3335 10.1C11.3668 10.1 11.4252 10.0833 11.4752 10.0167L13.4002 7.53334C13.6085 7.25834 14.0085 7.20834 14.2752 7.42501C14.5502 7.63334 14.6002 8.02501 14.3835 8.30001L12.4585 10.7833C12.2168 11.0917 11.8752 11.2917 11.4835 11.3333C11.0918 11.3833 10.7085 11.275 10.4002 11.0333L8.87517 9.83334C8.81684 9.78334 8.75017 9.78334 8.71684 9.79167C8.68351 9.79167 8.62517 9.80834 8.57517 9.87501L6.59184 12.45C6.48351 12.6167 6.30017 12.7 6.10851 12.7Z",
    fill: "#B90022"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.b560adb47f35d67a8656c35fb13802d1.svg";
export { ForwardRef as ReactComponent };